/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable import/prefer-default-export */
/**
 *
 * @param {*} arr Array in which want to remove duplicates
 * @returns
 */

export const removeDuplicates = arr => {
  return arr.filter((item, index) => arr.indexOf(item) === index)
}
export function htmlToPlainText(htmlString: string) {
  const tempElement = document.createElement('div')
  tempElement.innerHTML = htmlString
  const plainText = tempElement.textContent || tempElement.innerText || ''
  return plainText
}
